<template>
    <div>
        <div class="progress_bar" v-show="ProgressBar" style="top:10;">
            <v-progress-circular
            indeterminate
            :size="50"
            :width="15"
            :rotate="180"
            :value="value"
            class="main_font_color"
            >            
            </v-progress-circular>
        </div>
       
        <form @submit.prevent="checkout" v-show="!ProgressBar">   
            <v-layout>       
                <!---------Feature----------------------->
                <v-container>
                    <v-layout row wrap>                 
                        <!--------------- Checkout ---------------------->                     
                        <v-flex xs12 sm12 md12 class="your_order pb-3 right_part">
                            <v-card>
                                <v-list xs12 style="border-bottom:1px solid #E0E0E0;">
                                    <v-list-tile>
                                    <v-list-tile-title  class="grey--text text--darken-3 title text-xs-center">Tilaus</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                                <div class="white div_scroll">
                                    <div class="item_table">                           
                                        <v-list xs12 >
                                            <v-list-tile class="order_head">
                                                <v-list-tile-title class="body-2 grey--text text--darken-3"><b>Tuotemäärä<span class="right body-2 main_font_color"> {{cart.length}}</span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>                         
                                        <v-list xs12 >
                                            <v-list-tile class="order_head">
                                                <v-list-tile-title class="body-2 grey--text text--darken-3"><b>Kokonaishinta<span class="right body-2 main_font_color">{{currency}}{{cartTotal}}</span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                        <!-- <v-list xs12 >
                                            <v-list-tile class="order_head">
                                                <v-list-tile-title class="body-2 grey--text text--darken-3">
                                                <b>ALV Hinta<span class="right body-2 grey--text text--darken-3"><span class="main_font_color">{{currency}}{{Vat_Total.toFixed(2)}}</span></span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list> -->
                                            <v-list xs12 >
                                            <v-list-tile class="order_head">
                                                <v-list-tile-title class="body-2 grey--text text--darken-3">
                                                <b>ALV Hinta - %14<span class="right body-2 grey--text text--darken-3"><span class="main_font_color">{{currency}}{{Vat_Total14.toFixed(2)}}</span></span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                            <v-list xs12 >
                                            <v-list-tile class="order_head">
                                                <v-list-tile-title class="body-2 grey--text text--darken-3">
                                                <b>ALV Hinta - %24<span class="right body-2 grey--text text--darken-3"><span class="main_font_color">{{currency}}{{Vat_Total24.toFixed(2)}}</span></span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                        <v-list xs12 >
                                            <v-list-tile>
                                                <v-list-tile-title class="title grey--text text--darken-3"><b>Summa<span class="right title main_font_color">{{currency}}{{cartTotalWithShipping}}</span></b>
                                                </v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </div>
                                </div>                       
                                <v-list-tile-action>
                                    <v-btn type="submit" block dark class="mx-3 mb-3 green">Tee Tilaus</v-btn>
                                </v-list-tile-action>
                                <p style="color:red;text-align:center;margin-top:5px;" v-if="this.feedback">{{this.feedback}}</p>      
                            </v-card>    
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-layout>
        </form>
    </div>
</template>
     
<script>
   import firebase from "firebase";
   import moment from 'moment'   
   import axios from "axios";
   export default {
    data(){
        return{
            currency:null,
            userId:null, 
            name:null,
            email:null,
            password:null,
            phone:null,
            email:null,
            country:null,
            city:null,
            address:null,
            shipping:null,           
            cart:[],
            Vat_Total:0,
            Vat_Total14:0,
            Vat_Total24:0,
            timestamp:Date.now(),
            userLoggedin:null,
            checkoutTotal:null,
            account:[],   
            feedback:null,
            interval: {},
            value: 0,
            ProgressBar:true         
        }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods:{
        checkout(){
            this.ProgressBar = true
            var db = firebase.firestore();           
            var user = firebase.auth().currentUser;
            var datex=Math.floor(Date.now() / 1000);
            var cartx=[]

            this.cart.forEach(item => {
                if(item.product.iscampaign==false)
                {
                      item.product.discountpercent=0
                item.product.discount=0
                item.product.ismanualdiscountonly=false
                }
                else
                {
                //      item.product.discountpercent=item.product.discount_ratio
                // item.product.discount=item.product.discount_Euro
                    item.product.ismanualdiscountonly=true
                }

                item.product.amount=item.product.packageamount*item.quantity
          //         item.product.price=item.product.packageamount*item.product.price
                item.product.quantity=item.product.packageamount*item.quantity
                item.product.packageamount=item.quantity,
                item.product.price=parseFloat(item.product.price),
                item.product.package_price=parseFloat(item.product.package_price),
                item.product.note="Tukkupakkaus(" + item.quantity + "kpl) x "+ item.product.packageamount,
                // item.product.discountpercent=0,
                // item.product.discount=0,
        //        item.product.ismanualdiscountonly=false,
             
                cartx.push(item.product)
            });

               var data2= {
      "language":"en",
      "version":1,
      "saleorder": {   
      "paymentterm_id": "d83aa866-4cd3-11e9-be3f-fa163e3c66dd",    
      "branch_id": "b9611ab4-7eb7-11e8-a292-fa163e230d19",    
      "customer_id": this.account.customer_id,
      "vatstatus_id":1    
      },  
      "rows": cartx
     };
//   let res =  axios.post("http://localhost:5001/elatukku-23ef3/europe-west1/createorder", 
    let res =  axios.post("https://europe-west1-elatukku-23ef3.cloudfunctions.net/createorder", 
                 data2, 
    //              { headers: {
    //   'Content-type': 'application/x-www-form-urlencoded'
    //   }
    //   }
      ).then(res=> {
         

      if(res.data.code=="fail")      
      {
      this.feedback="FAIL: " + res.data.message
      return;
      }
      else
      {
                    this.ProgressBar = false
                     this.$store.commit('emptyCart')                   
                this.$router.push({ name: 'Success'})
                this.$store.commit('rightNavbar', 0)   
                
          var obj4=parseInt(res.data.context.ordernumber)  

          if(this.cart.length > 0){
                db.collection("orders").doc(datex.toString()).set({                
                    cart:this.cart,
                    quantity:this.cart.length,
                    checkout_total:this.checkoutTotal,
                    order_status:"Pending",
                    order_type:"Online Customer",
                    ordernumber:obj4,
                    user_id:user.uid,
                    name:this.account.name,
                    email:this.account.email,               
                    phone:this.account.phone,               
                    country:this.account.country,               
                    city:this.account.city,               
                    address:this.account.address,
                    path:datex,
                    time:moment().format('HH-mm'),
                    date:moment().format('YYYY-MM-DD'),
                    duration:60,
                    created_date:moment().format('DD-MM-YYYY'),
                    created_month:moment().format('MM-YYYY'),               
                    created_year:moment().format('YYYY'),               
                    timestamp:datex
                }).catch(function(err) {
                    this.feedback = "Error: "+ err
                    console.log(err);                
                });



            }else{
                this.feedback = "The cart is empty"
            }

             
       }
     
                //   var obj4=parseInt(res.data.context.ordernumber)            
                //    db.collection("orders").doc(datex.toString()).update({
                //        ordernumber:obj4 
                //    })
                // })
                //   .catch(error => { console.log(error); });


            
                   
        })
    }
    },
    computed:{
        cartTotal(){
            var total=0;
            this.cart.forEach(item => {
                if(item.product.iscampaign==false)
                total += parseFloat(item.product.package_price * item.quantity)
                else
                total += parseFloat(item.product.discounted_package_price * item.quantity)
            });
            return total.toFixed(2);
        },
        cartTotalWithShipping(){
            var total=0;
            var vat14=0;
            var vat24=0;
        //    this.Vat_Total=0;
            // this.Vat_Total14=0;
            // this.Vat_Total24=0;

            this.cart.forEach(item => {
                
                if(item.product.vatpercent=="14.0")
                {
                    if(item.product.iscampaign==false)
                    {
                        this.Vat_Total+=parseFloat(item.product.package_price*item.quantity)*14/100;
                        vat14+=parseFloat(item.product.package_price*item.quantity)*14/100;
                        total += parseFloat(item.product.package_price * item.quantity)
                        }
                    else
                    {
                        this.Vat_Total+=parseFloat(item.product.discounted_package_price*item.quantity)*14/100;
                        vat14+=parseFloat(item.product.discounted_package_price*item.quantity)*14/100;
                        total += parseFloat(item.product.discounted_package_price * item.quantity)
                    }
                }
                else if(item.product.vatpercent=="24.0")
                {
                    if(item.product.iscampaign==false)
                    {
                        this.Vat_Total+=parseFloat(item.product.package_price*item.quantity)*24/100;
                        vat24+=parseFloat(item.product.package_price*item.quantity)*24/100;
                        total += parseFloat(item.product.package_price * item.quantity)
                    }
                    else
                    {
                        this.Vat_Total+=parseFloat(item.product.discounted_package_price*item.quantity)*24/100;
                        vat24+=parseFloat(item.product.discounted_package_price*item.quantity)*24/100;
                          total += parseFloat(item.product.discounted_package_price * item.quantity)
                    }
                }
                this.Vat_Total14=vat14;
                this.Vat_Total24=vat24;

        //        total += parseFloat(item.product.package_price * item.quantity)
            });
            this.checkoutTotal = ((parseFloat(total)+parseFloat(this.shipping))).toFixed(2);
            return (parseFloat(total)+parseFloat(vat14+vat24)).toFixed(2);
        }          
    },
    created(){
        var db = firebase.firestore();
        // Current Currency   
        db.collection("settings").doc('config').onSnapshot(doc =>{
          this.currency = doc.data().currency
        })
        
        // Current Shipping Fee
        db.collection("settings").doc('config').onSnapshot(doc =>{
            this.shipping = doc.data().shipping
        })

        var user = firebase.auth().currentUser;
        if (user) {
            this.userId = user.uid            
            this.email = user.email            
            this.userLoggedin = true;          
        } else {
            this.userLoggedin = false;            
        }

        // User Profile Information       
        db.collection("profiles").doc(this.userId).onSnapshot(doc =>{
          this.account = doc.data()          
        })
    },
    mounted(){
        this.cart = this.$store.getters.cart
        
        // Progress Bar - Set value after this.value to increase/ decrease progress time
        this.interval = setInterval(() => {
            if (this.value === 50) {
            return this.ProgressBar = false
            }
            this.value += 50
        }, 1000)
    }
   }
</script>
  
<style scoped>
  .progress_bar{
    height: 200px;  
    text-align: center;
    line-height: 200px;
  }
  .progress-circular{
    margin: 15rem
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/checkout/Checkout.vue